/* ============================================================================
   sf-rx.js — STARKFELD Prescription Selling, Flow-Engine (24.09.2026)

   Eine Engine fuer alle Rezept-Flows: allgemein (Ziel waehlen), Recovery und
   Health. Welche Schritte laufen, steht in der Konfiguration der Section
   (<script type="application/json" data-rx-config>), nicht im Code.

   Schritte (Zustandsmaschine): goal -> sex -> zones -> symptoms -> details ->
   result. Im Modus "recovery"/"health" entfaellt goal. Browser-Zurueck fuehrt
   einen Schritt zurueck (History-API), Einstieg mit ?rx=recovery bzw. ?rx=health.

   Fassung 2 (24.09.2026 abends, Nayl: "fixe Breite, darf nicht jumpen, wie ein
   Quiz-Funnel"): feste Buehne mit EINEM CTA in der Fusszeile (sf-rx.css
   STG-01). Ziel und Frau/Mann gehen nach 180 ms automatisch weiter, am Handy
   laufen mehrere Zonen als Tabs, "Warum" und "Rechenbeispiel" sind Ebenen.
   Frau/Mann steuert nur die Figur und wird nie gemessen.

   Preise: EINE Quelle. Liegt der Set-Picker der Buybox auf der Seite
   (sf-set-picker, snippets/sf-bundle-picker.liquid), kommen Preise, Bestand,
   Streichpreis und Kit-UVP aus seinem JSON [data-sf-sets] und data-kit-price.
   Ohne Picker rechnet die Section mit denselben Werten aus Liquid (fallback).

   Uebergabe: 'sf:set-apply' an den Picker (detail { sets, replace:true }),
   Antwort 'sf:set-applied'; der Picker scrollt selbst zur Set-Auswahl.

   Messung: nur Ereignisse aus der Freigabeliste (rx_start, rx_step,
   rx_result, rx_cta) mit Flow, Schritt und Angebots-ID, NIE Antworten.
   Immer als DOM-Ereignis 'sf:rx'; an Shopify.analytics / dataLayer nur mit
   Statistik-Einwilligung.

   Fassung 4.0 (25.09.2026, SF-PDP-04): die Ratgeber-Links stehen serverseitig
   im HTML ([data-rx-goal-link], echte hrefs fuer Crawler), die Engine blendet nur
   den zum Ziel passenden ein. Die Figuren-Fotos (2 x ~120 KB WebP) tragen
   data-rx-src und werden erst geladen, wenn der Flow in die Naehe des Bildschirms
   kommt (loadFigures), auch beim ersten Klick.

   Fassung 4.1 (28.09.2026, SF-BESCH-00-S3): Andockpunkte fuer den Beschwerden-Check
   (assets/sf-rx-check.js, nur flow_mode "health"). Liegt in der Section ein
   [data-rx-check] und ist window.SFRxCheck geladen, uebernimmt der Check Reihenfolge,
   Pflichtangaben, CTA-Texte und die Auswertung; alle Aufrufe stehen hinter "if (this.chk)".
   Ohne Check (PDP, Library) laeuft alles wie in 4.0.

   Reine Logik (recommend, cost, money) ist ohne DOM testbar:
   Node: require('./sf-rx.js') -> { recommend, cost, formatMoney, ... }.
   ============================================================================ */
(function (root) {
  'use strict';

  var ZONES = ['legs', 'arms', 'hips'];

  /* ------------------------------------------------------------ Logik */

  function orderZones(list) {
    list = list || [];
    return ZONES.filter(function (z) { return list.indexOf(z) !== -1; });
  }

  /* Empfehlung aus den gewaehlten Zonen.
     prices: { boots, sleeves, hips, kit, kitUvp } in Cent,
             available: { boots, sleeves, hips, kit } (Standard true),
             compare: { boots, sleeves, hips } Streichpreise in Cent (0 = keiner).
     Regeln:
     1. STARKSLEEVES und STARKHIPS sind Aufsaetze ohne eigenes Steuergeraet,
        sie laufen ueber den Smart Monitor der STARKBOOTS V2. Deshalb gehoeren
        die Boots zu jeder Empfehlung.
     2. Das Kit (Boots + Sleeves + Hips + Tasche) wird empfohlen, sobald es
        nicht teurer ist als die noetigen Einzelteile, oder wenn ein noetiges
        Einzelteil nicht lieferbar ist.
     3. Sonst die Einzelteile; dazu ein Kit-Hinweis mit Aufpreis und Ersparnis. */
  function recommend(zones, prices) {
    var z = orderZones(zones);
    if (!z.length || !prices) return null;
    var av = prices.available || {};
    var ok = function (k) { return av[k] !== false && (prices[k] || 0) > 0; };
    var singles = ['boots'];
    if (z.indexOf('arms') !== -1) singles.push('sleeves');
    if (z.indexOf('hips') !== -1) singles.push('hips');
    var singleTotal = singles.reduce(function (s, k) { return s + (prices[k] || 0); }, 0);
    var singlesOk = singles.every(ok);
    var kitOk = ok('kit');
    var useKit = kitOk && (!singlesOk || prices.kit <= singleTotal);
    if (!useKit && !singlesOk) return null;

    var lines = useKit ? ['kit'] : singles.slice();
    var total = useKit ? prices.kit : singleTotal;
    var compare = 0;
    if (useKit) {
      compare = prices.kitUvp > prices.kit ? prices.kitUvp : 0;
    } else {
      var cmp = prices.compare || {};
      var withCompare = singles.reduce(function (s, k) {
        return s + ((cmp[k] || 0) > (prices[k] || 0) ? cmp[k] : (prices[k] || 0));
      }, 0);
      compare = withCompare > total ? withCompare : 0;
    }
    var saving = compare > total ? compare - total : 0;

    var hint = null;
    if (!useKit && kitOk) {
      hint = {
        key: singles.length === 1 ? 'legs' : (singles.indexOf('sleeves') !== -1 && singles.indexOf('hips') !== -1 ? 'default' : (singles.indexOf('sleeves') !== -1 ? 'legs_arms' : 'legs_hips')),
        delta: prices.kit - total,
        saving: prices.kitUvp > prices.kit ? prices.kitUvp - prices.kit : 0,
        savingPct: prices.kitUvp > prices.kit ? Math.round((prices.kitUvp - prices.kit) * 100 / prices.kitUvp) : 0,
        adds: ['sleeves', 'hips'].filter(function (k) { return singles.indexOf(k) === -1; }).concat(['bag'])
      };
    }

    return {
      id: lines.join('+'),
      kit: useKit,
      lines: lines,
      zones: z,
      bootsAdded: z.indexOf('legs') === -1,
      kitCheaper: useKit && singlesOk && prices.kit < singleTotal,
      singleTotal: singleTotal,
      total: total,
      compare: compare,
      saving: saving,
      savingPct: compare ? Math.round(saving * 100 / compare) : 0,
      kitHint: hint
    };
  }

  /* Rechenbeispiel (Nayl 24.09.2026: korrigieren und behalten).
     o: { perYear (Behandlungen/Jahr), perSession (Cent je Termin),
          hoursPerSession, usesPerWeek, months (Nutzungsdauer), price (Cent) } */
  function cost(o) {
    o = o || {};
    var perYear = Math.max(0, o.perYear || 0);
    var yearlyCost = Math.round(perYear * (o.perSession || 0));
    var hours = Math.round(perYear * (o.hoursPerSession || 0) * 10) / 10;
    var monthly = yearlyCost / 12;
    var months = o.months || 24;
    var uses = Math.round((o.usesPerWeek || 0) * months * 52 / 12);
    return {
      yearlyCost: yearlyCost,
      hours: hours,
      amortMonths: monthly > 0 && o.price > 0 ? Math.max(1, Math.ceil(o.price / monthly)) : null,
      uses: uses,
      perUse: uses > 0 && o.price > 0 ? Math.round(o.price / uses) : null
    };
  }

  /* Geld exakt wie die Buybox (sf-bundle-picker: '€' + de-DE, "€849,90"). */
  function formatMoney(cents) {
    return '€' + formatNumber((cents || 0) / 100, 2);
  }

  function formatNumber(n, digits) {
    var d = digits || 0;
    var s = (Math.round(n * Math.pow(10, d)) / Math.pow(10, d)).toFixed(d).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (d ? ',' + s[1] : '');
  }

  function joinDe(list) {
    if (list.length <= 1) return list.join('');
    return list.slice(0, -1).join(', ') + ' und ' + list[list.length - 1];
  }

  var logic = { recommend: recommend, cost: cost, formatMoney: formatMoney, formatNumber: formatNumber, joinDe: joinDe, orderZones: orderZones };
  if (typeof module !== 'undefined' && module.exports) { module.exports = logic; }
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.SFRx = window.SFRx || logic;
  if (!window.customElements || customElements.get('sf-rx')) return;

  /* ------------------------------------------------------------ Messung */

  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return false;
      if (typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
      var c = cp.currentVisitorConsent && cp.currentVisitorConsent();
      return !!c && (c.analytics === 'yes' || c.analytics === true);
    } catch (e) { return false; }
  }

  var ALLOWED_EVENTS = { rx_start: 1, rx_step: 1, rx_result: 1, rx_cta: 1 };
  var ALLOWED_KEYS = { flow: 1, step: 1, step_id: 1, offer: 1, action: 1, size_chosen: 1 };
  function track(name, data) {
    if (!ALLOWED_EVENTS[name]) return;
    var payload = {};
    Object.keys(data || {}).forEach(function (k) { if (ALLOWED_KEYS[k]) payload[k] = data[k]; });
    try { document.dispatchEvent(new CustomEvent('sf:rx', { detail: { name: name, data: payload } })); } catch (e) {}
    if (!analyticsAllowed()) return;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('sf_' + name, payload); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'sf_' + name }, payload)); } catch (e) {}
  }

  /* ------------------------------------------------------------ Hilfen */

  var AUTO_MS = 180, LEAVE_MS = 170, ENTER_MS = 340;
  var reduceMotion = function () {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
  var narrow = function () {
    return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  };
  /* "€1.920" statt "€1.920,00", wenn der Betrag glatt ist (Knopf "Rechenbeispiel") */
  var moneyShort = function (c) {
    return c % 100 === 0 ? '€' + formatNumber(c / 100, 0) : formatMoney(c);
  };
  /* Nur Leisten abziehen, die wirklich kleben: der Header, wenn er sticky/fixed
     und sichtbar ist, und die Theme-Kaufleiste unten, wenn sie sichtbar ist. */
  function insets() {
    var top = 0, bottom = 0;
    var hdr = document.querySelector('.shopify-section-header, sticky-header, header.header');
    if (hdr) {
      var cs = getComputedStyle(hdr), r = hdr.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed') && r.bottom > 0) top = Math.max(0, r.bottom);
    }
    var bar = document.querySelector('product-sticky-form');
    if (bar) {
      var bs = getComputedStyle(bar), br = bar.getBoundingClientRect();
      if (bs.display !== 'none' && bs.visibility !== 'hidden' && parseFloat(bs.opacity || '1') > .05 && br.height > 0 && br.top < window.innerHeight) {
        bottom = Math.max(0, window.innerHeight - br.top);
      }
    }
    return { top: top, bottom: bottom };
  }

  /* ------------------------------------------------------------ Element */

  customElements.define('sf-rx', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      try {
        this.cfg = JSON.parse(this.querySelector('[data-rx-config]').textContent);
      } catch (e) {
        return;
      }
      this._ready = true;
      var cfg = this.cfg;
      this.uid = cfg.uid;
      this.hkey = 'sfRx:' + this.uid;
      this.order = cfg.mode === 'general' ? ['goal', 'sex', 'zones', 'symptoms', 'details', 'result'] : ['sex', 'zones', 'symptoms', 'details', 'result'];
      this.state = {
        step: this.order[0],
        goal: cfg.mode === 'general' ? null : cfg.mode,
        sex: null,
        zones: [],
        symptoms: [],
        intensity: cfg.intensityDefault || 3,
        frequency: null,
        treatment: null,
        sizeChoice: null,
        tab: null,
        seen: {}
      };
      /* Beschwerden-Check (4.1): eigene Schritte aus sf-rx-check.js, nur wenn beides da ist */
      this.chk = null;
      var chkEl = this.querySelector('[data-rx-check]');
      if (chkEl && window.SFRxCheck && typeof window.SFRxCheck.attach === 'function') {
        try { this.chk = window.SFRxCheck.attach(this, JSON.parse(chkEl.textContent)); }
        catch (e) { this.chk = null; if (window.console) console.warn('[sf-rx] Check nicht geladen', e); }
      }
      this.started = false;
      this._timers = [];
      this.stage = this.querySelector('[data-rx-stage]');
      this.live = this.querySelector('[data-rx-live]');
      this.progress = this.querySelector('[data-rx-progress]');
      this.back = this.querySelector('[data-rx-back]');
      this.restartBtn = this.querySelector('[data-rx-restart]');
      this.foot = {
        trust: this.querySelector('[data-rx-trust]'),
        skip: this.querySelector('[data-rx-skip]'),
        cta: this.querySelector('[data-rx-cta-main]'),
        need: this.querySelector('[data-rx-need]'),
        more: this.querySelector('[data-rx-more]')
      };
      this._depth = 0;

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onKey = this.onKey.bind(this);
      this.onPop = this.onPop.bind(this);
      this.onApplied = this.onApplied.bind(this);
      this.queuePin = this.queuePin.bind(this);
      this.onMq = this.onMq.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onKey);
      window.addEventListener('popstate', this.onPop);
      window.addEventListener('sf:set-applied', this.onApplied);
      window.addEventListener('scroll', this.queuePin, { passive: true });
      window.addEventListener('resize', this.queuePin);
      if (window.matchMedia) {
        this.mq = window.matchMedia('(max-width: 1023px)');
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
        this.mqWide = window.matchMedia('(min-width: 1280px)');
        if (this.mqWide.addEventListener) this.mqWide.addEventListener('change', this.onMq);
      }
      var self = this;
      if (window.ResizeObserver) this.ro = new ResizeObserver(function () { self.guard(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.guard(); });
      if (cfg.hideBuybar && window.IntersectionObserver && this.stage) {
        this.io = new IntersectionObserver(function (en) {
          document.documentElement.classList.toggle('sf-rx-in-view', en[0].intersectionRatio >= 0.35);
        }, { threshold: [0, 0.35, 0.6, 1] });
        this.io.observe(this.stage);
      }
      /* Figuren erst laden, wenn der Flow in die Naehe kommt (900 px Vorlauf) */
      if (this.querySelector('image[data-rx-src]')) {
        if (window.IntersectionObserver) {
          this.ioFig = new IntersectionObserver(function (en) {
            for (var i = 0; i < en.length; i++) if (en[i].isIntersecting) { self.loadFigures(); break; }
          }, { rootMargin: '900px 0px' });
          this.ioFig.observe(this);
        } else this.loadFigures();
      }

      this.applyGoalTexts();
      this.setFigure('n');
      this.syncZones();
      this.readSymptoms();
      this.syncDetails();

      var q = null;
      try { q = new URLSearchParams(window.location.search).get('rx'); } catch (e) {}
      if (cfg.mode === 'general' && q && cfg.goals[q]) {
        this.state.goal = q;
        this.applyGoalTexts();
        this.syncGoal();
        this.show('sex', { instant: true });
        requestAnimationFrame(function () { self.keepInView(); });
      } else {
        this.show(this.state.step, { instant: true });
      }
      this.writeHistory(false);
      this.onPageHide = this.onPageHide.bind(this);
      this.onPageShow = this.onPageShow.bind(this);
      window.addEventListener('pagehide', this.onPageHide);
      window.addEventListener('pageshow', this.onPageShow);
    }

    /* History: jeder Schritt ein Eintrag mit Tiefe. Solange der Flow eigene
       Eintraege hat, stellt der Browser beim Zurueck KEINE alte Scrollposition
       wieder her (sonst springt der Rahmen, Pruefbefund L2/A11Y-02); nur
       keepInView() entscheidet. Beim Verlassen der Seite wieder 'auto'. */
    writeHistory(push) {
      try {
        var patch = {};
        if (push) this._depth++;
        /* Check: history.state kann jedes Skript lesen, deshalb nie den Schrittnamen (4.1) */
        if (this.chk) { this._hs = this._hs || {}; this._hs[this._depth] = this.state.step; }
        patch[this.hkey] = this.chk ? 'rx' : this.state.step;
        patch[this.hkey + '#'] = this._depth;
        var next = Object.assign({}, history.state || {}, patch);
        if (push) {
          if (this._depth === 1 && 'scrollRestoration' in history) {
            if (this._restoreScroll == null) this._restoreScroll = history.scrollRestoration;
            history.scrollRestoration = 'manual';
          }
          history.pushState(next, '');
        } else {
          history.replaceState(next, '');
        }
      } catch (e) {}
    }

    onPageHide() {
      try { if (this._restoreScroll != null) history.scrollRestoration = this._restoreScroll; } catch (e) {}
    }

    onPageShow() {
      try { if (this._depth > 0 && 'scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    }

    /* Figuren-Fotos nachladen (data-rx-src -> href), einmalig */
    loadFigures() {
      var imgs = this.querySelectorAll('image[data-rx-src]');
      for (var i = 0; i < imgs.length; i++) { imgs[i].setAttribute('href', imgs[i].getAttribute('data-rx-src')); imgs[i].removeAttribute('data-rx-src'); }
      if (this.ioFig) { this.ioFig.disconnect(); this.ioFig = null; }
    }

    disconnectedCallback() {
      if (this.ioFig) { this.ioFig.disconnect(); this.ioFig = null; }
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('keydown', this.onKey);
      window.removeEventListener('popstate', this.onPop);
      window.removeEventListener('sf:set-applied', this.onApplied);
      window.removeEventListener('pagehide', this.onPageHide);
      window.removeEventListener('pageshow', this.onPageShow);
      this.onPageHide();
      window.removeEventListener('scroll', this.queuePin);
      window.removeEventListener('resize', this.queuePin);
      if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
      if (this.mqWide && this.mqWide.removeEventListener) this.mqWide.removeEventListener('change', this.onMq);
      if (this.ro) this.ro.disconnect();
      if (this.io) { this.io.disconnect(); document.documentElement.classList.remove('sf-rx-in-view'); }
      this.finishSwap();
      clearTimeout(this._auto);
      clearTimeout(this._fallbackTimer);
      this._ready = false;
    }

    /* ---------------------------------------------------- Ereignisse */

    onClick(e) {
      if (this.ioFig) this.loadFigures();
      if (this.chk && this.chk.onClick(e)) { if (this.foot.need && !this.foot.need.hidden) this.hideNeed(); return; }
      var t = e.target.closest('[data-rx-goal],[data-rx-sex],[data-rx-skip],[data-rx-zone-hit],[data-rx-tab],[data-rx-cta-main],[data-rx-back],[data-rx-restart],[data-rx-kit],[data-rx-sheet],[data-rx-sheet-close],[data-rx-size-tip],[data-rx-prod-toggle]');
      if (this.foot.need && !this.foot.need.hidden && !(t && t.hasAttribute('data-rx-cta-main'))) this.hideNeed();
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute('data-rx-goal')) {
        if (this._lock) return;
        this.begin();
        var g = t.getAttribute('data-rx-goal');
        if (g !== this.state.goal) {
          if (this.state.goal) { this.state.frequency = null; this.state.intensity = this.cfg.intensityDefault || 3; }
          this.state.goal = g;
          this.applyGoalTexts();
          this.syncDetails();
        }
        this.syncGoal();
        this.autoNext();
      } else if (t.hasAttribute('data-rx-sex')) {
        if (this._lock) return;
        this.begin();
        this.state.sex = t.getAttribute('data-rx-sex');
        this.setFigure(this.state.sex);
        this.syncSex();
        this.autoNext();
      } else if (t.hasAttribute('data-rx-skip')) {
        if (this._lock) return;
        this.begin();
        this.state.sex = 'n';
        this.setFigure('n');
        this.syncSex();
        this.next();
      } else if (t.hasAttribute('data-rx-zone-hit')) {
        if (this.state.step !== 'zones') return;
        var box = this.querySelector('[data-rx-zone-input="' + t.getAttribute('data-rx-zone-hit') + '"]');
        if (box) { box.checked = !box.checked; this.begin(); this.readZones(); }
      } else if (t.hasAttribute('data-rx-tab')) {
        this.selectTab(t.getAttribute('data-rx-tab'), false);
      } else if (t.hasAttribute('data-rx-size-tip')) {
        this.openSizeFinder(t);
      } else if (t.hasAttribute('data-rx-prod-toggle')) {
        this.toggleProd(t);
      } else if (t.hasAttribute('data-rx-cta-main')) {
        this.onCta();
      } else if (t.hasAttribute('data-rx-back')) {
        this.stepBack();
      } else if (t.hasAttribute('data-rx-restart')) {
        this.restart();
      } else if (t.hasAttribute('data-rx-kit')) {
        this.apply(true);
      } else if (t.hasAttribute('data-rx-sheet')) {
        this.openSheet(t.getAttribute('data-rx-sheet'), t);
      } else if (t.hasAttribute('data-rx-sheet-close')) {
        this.closeSheet(t.closest('[data-rx-sheet-panel]'), true);
      }
    }

    onChange(e) {
      var t = e.target;
      if (!this.contains(t)) return;
      this.begin();
      if (this.chk && this.chk.onChange(t)) return;
      if (t.hasAttribute('data-rx-zone-input')) this.readZones();
      else if (t.name === this.uid + '-sym') this.readSymptoms();
      else if (t.name === this.uid + '-int') { this.state.intensity = parseInt(t.value, 10); this.syncDetails(); }
      else if (t.name === this.uid + '-freq') { this.state.frequency = t.value; this.syncDetails(); }
      else if (t.name === this.uid + '-treat') { this.state.treatment = t.value; this.syncDetails(); }
      else if (t.name === this.uid + '-size') { this.state.sizeChoice = t.value; this.renderSizes(); }
    }

    onKey(e) {
      var t = e.target;
      if (this.chk && this.chk.onKey(e)) return;
      if (t && t.getAttribute && t.getAttribute('role') === 'tab' && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        var tabs = [].filter.call(this.querySelectorAll('[data-rx-tab]'), function (b) { return !b.hidden; });
        var i = tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
        i = (i + tabs.length) % tabs.length;
        this.selectTab(tabs[i].getAttribute('data-rx-tab'), false);
        tabs[i].focus();
        e.preventDefault();
      }
      if (e.key === 'Escape') {
        var open = this.querySelector('[data-rx-sheet-panel]:not([hidden])');
        if (open) { this.closeSheet(open, true); e.preventDefault(); }
      }
    }

    onPop(e) {
      var hs = e.state || {};
      var step = hs[this.hkey];
      if (!step) return;
      this._depth = hs[this.hkey + '#'] || 0;
      if (this.chk) {
        clearTimeout(this._auto); this._lock = false;
        step = (this._hs && this._hs[this._depth]) || this.order[0];
      }
      if (this._restarting) {
        this._restarting = false;
        this.show(this.order[0], { focus: true, dir: 'back' });
        this.writeHistory(false);
        return;
      }
      if (this.order.indexOf(step) === -1 || step === this.state.step) return;
      /* Nicht mehr erreichbar (z. B. Antworten geaendert)? Den naechsten erreichbaren frueheren Schritt zeigen. */
      var i = this.order.indexOf(step);
      while (i > 0 && !this.reachable(this.order[i])) i--;
      /* Browser-Vorwaerts auf einen nicht mehr erreichbaren Schritt (z. B. nach "Neu starten"): Sprung zuruecknehmen */
      if (this.order[i] !== step && this.order[i] === this.state.step) { history.back(); return; }
      this.show(this.order[i], { focus: true });
      if (this.order[i] !== step) this.writeHistory(false);
    }

    onMq() {
      if (this.chk && this.state.step === 'insight') this.chk.selectITab(this.chk.itab, false);
      this.applyTabRoles();
      this.syncProds();
      this.guard();
      this.queuePin();
    }

    begin() {
      if (this.started) return;
      this.started = true;
      track('rx_start', { flow: this.cfg.mode });
    }

    /* ---------------------------------------------------- Navigation */

    reachable(step) {
      if (this.chk) return this.chk.reachable(step);
      var st = this.state;
      switch (step) {
        case 'goal': return true;
        case 'sex': return !!st.goal;
        case 'zones': return !!st.goal && !!st.sex;
        case 'symptoms': return !!st.goal && !!st.sex && st.zones.length > 0;
        case 'details': return this.reachable('symptoms') && st.symptoms.length > 0;
        case 'result': return this.reachable('details') && !!st.frequency && !!st.treatment;
      }
      return false;
    }

    ready(step) {
      if (this.chk) return this.chk.ready(step);
      var st = this.state;
      if (step === 'zones') return st.zones.length > 0;
      if (step === 'symptoms') return st.symptoms.length > 0;
      if (step === 'details') return !!st.frequency && !!st.treatment;
      return true;
    }

    next() {
      var i = this.order.indexOf(this.state.step);
      if (i < this.order.length - 1) this.go(this.order[i + 1]);
    }

    go(step) {
      if (!this.reachable(step)) return;
      this.show(step, { push: true, focus: true });
    }

    autoNext() {
      var self = this, from = this.state.step;
      this._lock = true;
      clearTimeout(this._auto);
      this._auto = setTimeout(function () { self._lock = false; if (!self.chk || self.state.step === from) self.next(); }, reduceMotion() ? 0 : AUTO_MS);
    }

    stepBack() {
      clearTimeout(this._auto); this._lock = false;
      var open = this.querySelector('[data-rx-sheet-panel]:not([hidden])');
      if (open) { this.closeSheet(open, true); return; }
      var i = this.order.indexOf(this.state.step);
      if (i <= 0) return;
      var hs = history.state || {};
      var cur = this.chk ? (this._hs && this._hs[this._depth]) : hs[this.hkey];
      if (this._depth > 0 && hs[this.hkey] && cur === this.state.step) { history.back(); return; }
      this.show(this.order[i - 1], { focus: true });
      this.writeHistory(false);
    }

    restart() {
      var st = this.state;
      clearTimeout(this._auto); this._lock = false;
      st.zones = []; st.symptoms = []; st.frequency = null; st.treatment = null; st.sizeChoice = null;
      st.sex = null; st.tab = null; st.seen = {};
      st.intensity = this.cfg.intensityDefault || 3;
      if (this.cfg.mode === 'general') st.goal = null;
      [].forEach.call(this.querySelectorAll('input'), function (i) { i.checked = false; });
      this.setFigure('n');
      if (this.chk) this.chk.reset();
      this.syncGoal(); this.syncSex(); this.syncZones(); this.readSymptoms(); this.syncDetails();
      if (this._depth > 0) {
        this._restarting = true;
        history.go(-this._depth);
        return;
      }
      this.show(this.order[0], { focus: true, dir: 'back' });
      this.writeHistory(false);
    }

    /* Schliesst einen laufenden Wechsel sofort ab (schnelles Tippen) */
    finishSwap() {
      this._timers.forEach(clearTimeout);
      this._timers = [];
      var cur = this.state && this.state.step;
      [].forEach.call(this.querySelectorAll('[data-rx-step]'), function (p) {
        p.classList.remove('is-entering', 'is-leaving');
        p.inert = false; p.removeAttribute('aria-hidden');
        p.hidden = p.getAttribute('data-rx-step') !== cur;
      });
    }

    show(step, opts) {
      opts = opts || {};
      this.finishSwap();
      var prev = this.state.step;
      var idx = this.order.indexOf(step);
      var prevIdx = this.order.indexOf(prev);
      var dir = opts.dir || (idx < prevIdx ? 'back' : 'fwd');
      this.state.step = step;
      var stage = this.stage;
      if (stage) { stage.setAttribute('data-rx-at', step); stage.setAttribute('data-rx-dir', dir); }
      this.closeSheet(this.querySelector('[data-rx-sheet-panel]:not([hidden])'), false);
      if (step === 'symptoms') this.renderSymptoms();
      if (step === 'details') this.syncDetails();
      if (step === 'result') this.renderResult();
      if (this.chk) this.chk.onShow(step);

      var animate = !opts.instant && prev !== step && !reduceMotion();
      var self = this;
      [].forEach.call(this.querySelectorAll('[data-rx-step]'), function (p) {
        var name = p.getAttribute('data-rx-step');
        if (name === step) {
          p.hidden = false; p.inert = false; p.removeAttribute('aria-hidden');
          if (animate) {
            void p.offsetWidth;
            p.classList.add('is-entering');
            self._timers.push(setTimeout(function () { p.classList.remove('is-entering'); }, ENTER_MS));
          }
        } else if (animate && name === prev) {
          p.hidden = false; p.inert = true; p.setAttribute('aria-hidden', 'true');
          p.classList.add('is-leaving');
          self._timers.push(setTimeout(function () {
            p.hidden = true; p.classList.remove('is-leaving'); p.inert = false; p.removeAttribute('aria-hidden');
          }, LEAVE_MS));
        } else {
          p.hidden = true;
        }
      });
      if (this.back) this.back.hidden = idx <= 0;
      if (this.restartBtn) this.restartBtn.hidden = step !== 'result';
      if (this.chk) this.chk.afterShow(step);
      if (this.progress) {
        this.progress.setAttribute('aria-valuemax', String(this.order.length));
        this.progress.setAttribute('aria-valuenow', String(idx + 1));
        this.progress.setAttribute('aria-valuetext', 'Schritt ' + (idx + 1) + ' von ' + this.order.length);
      }
      this.syncFoot();
      if (this.ro) {
        this.ro.disconnect();
        var body = this.querySelector('[data-rx-step="' + step + '"] .sf-rx-panel__body');
        if (body) this.ro.observe(body);
      }
      this.guard();

      if (opts.push) this.writeHistory(true);
      if (opts.focus) {
        this.begin();
        var head = this.querySelector('[data-rx-step="' + step + '"] [data-rx-focus]');
        if (head) { head.setAttribute('tabindex', '-1'); head.focus({ preventScroll: true }); }
        this.announce('Schritt ' + (idx + 1) + ' von ' + this.order.length + (head ? ': ' + head.textContent.replace(/\s+/g, ' ').trim() : ''));
        this.keepInView();
        if (!this.chk) track('rx_step', { flow: this.cfg.mode, step: idx + 1, step_id: step });
        else {
          /* Check: feste Phase statt Schrittnummer, jede Phase einmal, Warnzeichen wie Abbruch (4.1) */
          var tid = this.chk.trackId(step), ph = this.chk.trackStep(step);
          if (tid && ph !== this._lastPhase) { this._lastPhase = ph; track('rx_step', { flow: this.cfg.mode, step: ph, step_id: tid }); }
        }
      }
      if (step === 'result' && prev !== 'result' && this.reco) {
        track('rx_result', this.chk ? { flow: this.cfg.mode } : { flow: this.cfg.mode, offer: this.reco.id });
      }
      this.queuePin();
    }

    announce(msg) {
      var live = this.live;
      if (!live) return;
      live.textContent = '';
      setTimeout(function () { live.textContent = msg; }, 60);
    }

    /* Der Rahmen aendert nie seine Groesse: normalerweise wird NICHT gescrollt.
       Nur wenn er angeschnitten ist, wird er zentriert bzw. oben angelegt. */
    keepInView() {
      if (!this.stage) return;
      var r = this.stage.getBoundingClientRect(), ins = insets();
      this.stage.style.setProperty('--rx-bottom-inset', ins.bottom + 'px');
      var avail = window.innerHeight - ins.top - ins.bottom;
      if (r.top >= ins.top - 1 && r.bottom <= window.innerHeight - ins.bottom + 1) return;
      var y = r.height <= avail ? window.pageYOffset + r.top - ins.top - Math.round((avail - r.height) / 2) : window.pageYOffset + r.top - ins.top - 8;
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduceMotion() ? 'auto' : 'smooth' });
    }

    queuePin() {
      if (this._pinQueued || !this.stage) return;
      this._pinQueued = true;
      var self = this;
      requestAnimationFrame(function () { self._pinQueued = false; self.pinCheck(); });
    }

    /* CTA anheften, wenn die Buehne oben anliegt, unten aber angeschnitten ist */
    pinCheck() {
      var r = this.stage.getBoundingClientRect(), ins = insets();
      this.stage.style.setProperty('--rx-bottom-inset', ins.bottom + 'px');
      var pin = r.top <= ins.top + 12 && r.bottom > window.innerHeight - ins.bottom + 1 && r.bottom > 0;
      this.stage.classList.toggle('is-pinned', pin);
    }

    /* Sicherheitsnetz: passt ein Inhalt doch nicht, scrollt nur der Inhalt */
    guard() {
      var body = this.querySelector('[data-rx-step="' + this.state.step + '"] .sf-rx-panel__body');
      if (!body) return;
      body.classList.remove('is-scroll');
      var over = body.scrollHeight - body.clientHeight;
      if (over > 1) {
        body.classList.add('is-scroll');
        this._warned = this._warned || {};
        if (!this._warned[this.state.step] && window.console) { this._warned[this.state.step] = 1; console.warn('[sf-rx] Inhalt zu hoch in Schritt', this.state.step, over + 'px'); }
      }
    }

    /* ---------------------------------------------------- Fusszeile */

    syncFoot() {
      var f = this.foot, step = this.state.step, T = this.cfg.texts;
      var stopped = this.chk && step === 'insight' && (this.chk.ev || this.chk.evaluate()).stop;
      var mode = stopped ? 'stop' : step === 'goal' ? 'trust' : step === 'sex' ? 'skip' : 'cta';
      if (f.trust) f.trust.hidden = mode !== 'trust';
      if (f.skip) f.skip.hidden = mode !== 'skip';
      if (f.more) f.more.hidden = step !== 'result' || !this.reco;
      if (f.cta) {
        f.cta.hidden = mode !== 'cta';
        if (mode === 'cta') {
          f.cta.textContent = (this.chk && this.chk.ctaLabel(step)) || (step === 'details' ? T.ctaResult : step === 'result' ? (this.reco ? T.ctaOrder : T.ctaFallback) : T.ctaNext);
          var ok = this.ready(step);
          f.cta.setAttribute('aria-disabled', ok ? 'false' : 'true');
        }
      }
      this.hideNeed();
    }

    showNeed(msg) {
      var n = this.foot.need;
      if (!n || !msg) return;
      n.hidden = false;
      n.textContent = msg;
      this.announce(msg);
    }

    hideNeed() {
      var n = this.foot.need;
      if (n) { n.hidden = true; n.textContent = ''; }
    }

    onCta() {
      var st = this.state, T = this.cfg.texts;
      if (this.chk && this._lock) return;
      var cta = this.foot.cta;
      if (cta && cta.getAttribute('aria-disabled') === 'true') {
        this.showNeed((this.chk && this.chk.needMsg(st.step)) || (st.step === 'zones' ? T.needZones : st.step === 'symptoms' ? T.needSymptoms : T.needDetails));
        return;
      }
      if (this.chk && this.chk.onCta()) return;
      if (st.step === 'symptoms' && narrow() && st.zones.length > 1) {
        /* "Weiter" fuehrt nur vorwaerts durch die noch nicht gesehenen Zonen, nie zurueck */
        st.seen[st.tab] = 1;
        var rest = st.zones.slice(st.zones.indexOf(st.tab) + 1).filter(function (z) { return !st.seen[z]; });
        if (rest.length) { this.selectTab(rest[0], true); return; }
      }
      if (st.step === 'result') {
        if (this.reco) this.apply(false); else this.fallback();
        return;
      }
      this.next();
    }

    /* ---------------------------------------------------- Ziel, Frau/Mann */

    syncGoal() {
      var g = this.state.goal;
      [].forEach.call(this.querySelectorAll('[data-rx-goal]'), function (b) {
        var on = b.getAttribute('data-rx-goal') === g;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var card = b.closest('.sf-rx-goal');
        if (card) card.classList.toggle('is-selected', on);
      });
    }

    syncSex() {
      var s = this.state.sex;
      [].forEach.call(this.querySelectorAll('[data-rx-sex]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-rx-sex') === s ? 'true' : 'false');
      });
    }

    setFigure(sex) {
      [].forEach.call(this.querySelectorAll('[data-rx-figure-host][data-rx-dyn]'), function (h) {
        h.setAttribute('data-rx-figure-host', sex === 'f' || sex === 'm' ? sex : 'n');
      });
    }

    applyGoalTexts() {
      var cfg = this.cfg;
      var g = cfg.goals[this.state.goal || cfg.defaultGoal];
      if (!g) return;
      var self = this;
      var set = function (sel, txt) { var el = self.querySelector(sel); if (el && txt != null) el.textContent = txt; };
      set('[data-rx-t="zones-title"]', g.zonesTitle);
      set('[data-rx-t="symptoms-title"]', g.symptomsTitle);
      set('[data-rx-t="details-title"]', g.detailsTitle);
      set('[data-rx-t="details-sub"]', g.detailsSub);
      set('[data-rx-t="q-int"]', g.qIntensity);
      set('[data-rx-t="q-freq"]', g.qFrequency);
      set('[data-rx-t="q-treat"]', g.qTreatment);
      (g.frequency || []).forEach(function (f, i) {
        set('[data-rx-t="freq-' + i + '-title"]', f.title);
        set('[data-rx-t="freq-' + i + '-desc"]', f.desc);
      });
    }

    /* ---------------------------------------------------- Zonen */

    readZones() {
      var self = this;
      this.state.zones = orderZones([].filter.call(this.querySelectorAll('[data-rx-zone-input]'), function (i) { return i.checked; })
        .map(function (i) { return i.getAttribute('data-rx-zone-input'); }));
      /* Symptome abgewaehlter Zonen fallen weg, alle anderen bleiben (Zurueck ohne Reset) */
      [].forEach.call(this.querySelectorAll('input[name="' + this.uid + '-sym"]'), function (i) {
        if (i.checked && self.state.zones.indexOf(i.getAttribute('data-zone')) === -1) i.checked = false;
      });
      this.readSymptoms();
      this.syncZones();
      if (this.chk) this.chk.onZones();
    }

    syncZones() {
      var zones = this.state.zones;
      [].forEach.call(this.querySelectorAll('[data-rx-zone-input]'), function (i) {
        i.checked = zones.indexOf(i.getAttribute('data-rx-zone-input')) !== -1;
      });
      [].forEach.call(this.querySelectorAll('[data-rx-region]'), function (g) {
        g.classList.toggle('is-on', zones.indexOf(g.getAttribute('data-rx-region')) !== -1);
      });
      if (this.state.step === 'zones') this.syncFoot();
    }

    /* ---------------------------------------------------- Beschwerden */

    renderSymptoms() {
      var st = this.state, self = this;
      var host = this.querySelector('[data-rx-symptoms]');
      if (!host) return;
      var zs = st.zones.slice();
      if (!st.tab || zs.indexOf(st.tab) === -1) st.tab = zs[0] || null;
      host.setAttribute('data-n', String(zs.length || 1));
      host.style.setProperty('--n', String(zs.length || 1));
      /* Symptome des anderen Ziels zaehlen nicht */
      [].forEach.call(this.querySelectorAll('input[name="' + this.uid + '-sym"]'), function (i) {
        if (i.checked && i.getAttribute('data-goal') !== st.goal) i.checked = false;
      });
      [].forEach.call(host.querySelectorAll('[data-rx-sym-group]'), function (fs) {
        var z = fs.getAttribute('data-rx-sym-group');
        fs.hidden = !(fs.getAttribute('data-rx-sym-goal') === st.goal && zs.indexOf(z) !== -1);
        fs.classList.toggle('is-active', z === st.tab);
      });
      [].forEach.call(host.querySelectorAll('[data-rx-tab]'), function (b) {
        var z = b.getAttribute('data-rx-tab');
        b.hidden = zs.indexOf(z) === -1;
        var on = z === st.tab;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
        b.tabIndex = on ? 0 : -1;
      });
      this.readSymptoms();
      this.applyTabRoles();
    }

    applyTabRoles() {
      var on = narrow() && this.state.zones.length > 1, st = this.state, uid = this.uid;
      var list = this.querySelector('[data-rx-tabs]');
      if (list) { if (on) list.setAttribute('role', 'tablist'); else list.removeAttribute('role'); }
      [].forEach.call(this.querySelectorAll('[data-rx-tab]'), function (b) {
        var z = b.getAttribute('data-rx-tab');
        if (on) { b.setAttribute('role', 'tab'); b.setAttribute('aria-controls', uid + '-grp-' + st.goal + '-' + z); }
        else { b.removeAttribute('role'); b.removeAttribute('aria-controls'); b.removeAttribute('aria-selected'); }
      });
      if (on) {
        [].forEach.call(this.querySelectorAll('[data-rx-tab]'), function (b) { b.setAttribute('aria-selected', b.getAttribute('data-rx-tab') === st.tab ? 'true' : 'false'); });
      }
      [].forEach.call(this.querySelectorAll('[data-rx-sym-group]'), function (g) {
        if (on) { g.setAttribute('role', 'tabpanel'); g.setAttribute('aria-labelledby', uid + '-tab-' + g.getAttribute('data-rx-sym-group')); }
        else { g.removeAttribute('role'); g.removeAttribute('aria-labelledby'); }
      });
    }

    selectTab(z, focus) {
      var st = this.state;
      st.tab = z;
      st.seen[z] = 1;
      [].forEach.call(this.querySelectorAll('[data-rx-tab]'), function (b) {
        var on = b.getAttribute('data-rx-tab') === z;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.classList.toggle('is-active', on);
        b.tabIndex = on ? 0 : -1;
      });
      [].forEach.call(this.querySelectorAll('[data-rx-sym-group]'), function (g) {
        g.classList.toggle('is-active', g.getAttribute('data-rx-sym-group') === z);
      });
      if (focus) {
        var tab = this.querySelector('[data-rx-tab="' + z + '"]');
        if (tab) tab.focus({ preventScroll: true });
        var label = this.cfg.zones[z] ? this.cfg.zones[z].label : z;
        this.announce(label + ': ' + this.cfg.texts.pickAll);
      }
      this.guard();
    }

    readSymptoms() {
      var self = this;
      this.state.symptoms = [].filter.call(this.querySelectorAll('input[name="' + this.uid + '-sym"]'), function (i) { return i.checked; })
        .map(function (i) { return i.value; });
      var syms = this.state.symptoms;
      [].forEach.call(this.querySelectorAll('[data-rx-sym-group]'), function (fs) {
        var n = fs.querySelectorAll('input:checked').length;
        var c = fs.querySelector('[data-rx-count]');
        if (c) { c.textContent = n ? String(n) : ''; c.hidden = !n; }
      });
      [].forEach.call(this.querySelectorAll('[data-rx-tab]'), function (b) {
        var z = b.getAttribute('data-rx-tab');
        var n = [].filter.call(self.querySelectorAll('input[name="' + self.uid + '-sym"][data-zone="' + z + '"]'), function (i) { return i.checked; }).length;
        var el = b.querySelector('.sf-rx-tab__n');
        if (el) el.textContent = n ? String(n) : '';
      });
      if (this.state.step === 'symptoms') this.syncFoot();
    }

    /* ---------------------------------------------------- Details */

    syncDetails() {
      var st = this.state;
      var self = this;
      [['-int', String(st.intensity)], ['-freq', st.frequency], ['-treat', st.treatment]].forEach(function (p) {
        [].forEach.call(self.querySelectorAll('input[name="' + self.uid + p[0] + '"]'), function (i) { i.checked = i.value === p[1]; });
      });
      if (st.step === 'details') this.syncFoot();
    }

    /* ---------------------------------------------------- Preise */

    readPrices() {
      var fb = this.cfg.fallback || {};
      var prices = {
        boots: fb.boots, sleeves: fb.sleeves, hips: fb.hips, kit: fb.kit, kitUvp: fb.kitUvp,
        compare: {}, available: {}, sizes: {}, images: {}
      };
      var picker = document.querySelector('sf-set-picker');
      this.picker = picker;
      if (!picker) return prices;
      var sets;
      try { sets = JSON.parse(picker.querySelector('[data-sf-sets]').textContent); } catch (e) { return prices; }
      var names = this.cfg.setNames;
      var norm = function (v) { return String(v || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
      Object.keys(names).forEach(function (k) {
        var s = sets.filter(function (x) { return norm(x.name) === norm(names[k]); })[0];
        if (!s) { prices.available[k] = false; return; }
        prices[k] = s.price;
        prices.compare[k] = s.compare || 0;
        prices.available[k] = !!s.available;
        prices.sizes[k] = s.sized ? s.sizes : null;
        if (s.img) prices.images[k] = s.img;
        if (k === 'kit' && s.items) {
          var bag = s.items.filter(function (it) { return it.bonus || /tasche/i.test(it.label || ''); })[0];
          if (bag) { prices.bagImg = bag.img || ''; prices.bagName = bag.label || ''; }
        }
      });
      var uvp = parseInt(picker.getAttribute('data-kit-price'), 10);
      if (uvp > 0) prices.kitUvp = uvp;
      return prices;
    }

    /* ---------------------------------------------------- Ergebnis */

    renderResult() {
      var st = this.state, cfg = this.cfg, T = cfg.texts, self = this;
      var goal = cfg.goals[st.goal] || cfg.goals[cfg.defaultGoal];
      this.prices = this.readPrices();
      var reco = recommend(st.zones, this.prices);
      this.reco = reco;
      var r = function (k) { return self.querySelector('[data-rx-r="' + k + '"]'); };
      var zoneLabel = function (z) { return cfg.zones[z].label; };
      var res = r('res');
      if (res) res.hidden = !reco;
      var empty = r('empty');
      if (empty) empty.hidden = !!reco;
      if (!reco) {
        r('title').textContent = T.resultFallback;
        r('sub').textContent = T.unavailable;
        return;
      }

      /* Kopf: Angebot als Titel, bei Ueberlauf "Deine Empfehlung" */
      var title = reco.kit ? (cfg.kit.title || cfg.setNames.kit) : reco.lines.map(function (k) { return cfg.setNames[k]; }).join(' + ');
      if (reco.lines.length > 2 && !reco.kit) title = T.resultFallback;
      var h = r('title');
      h.textContent = title;
      r('sub').textContent = T.resultSub.replace('[zones]', joinDe(st.zones.map(zoneLabel)));

      /* Produkte */
      var lineOf = { legs: 'boots', arms: 'sleeves', hips: 'hips' };
      var productZones = reco.kit ? ['legs', 'arms', 'hips'] : ['legs'].concat(reco.lines.indexOf('sleeves') !== -1 ? ['arms'] : [], reco.lines.indexOf('hips') !== -1 ? ['hips'] : []);
      var benefitsOf = function (z, chosen) {
        if (!chosen) return [T.monitorBenefit];
        var list = st.symptoms.filter(function (id) { return cfg.benefits[id] && cfg.benefits[id].zone === z; })
          .map(function (id) { return cfg.benefits[id].text; }).filter(Boolean);
        if (!list.length && cfg.defaults[z]) list = [cfg.defaults[z]];
        return list.slice(0, 3);
      };
      var chev = '<span class="sf-rx-prod__chev sf-rx-ico" aria-hidden="true"></span>';
      var rows = productZones.map(function (z) {
        var key = lineOf[z];
        var chosen = st.zones.indexOf(z) !== -1;
        var list = benefitsOf(z, chosen);
        var img = (self.prices.images && self.prices.images[key]) || cfg.zones[z].img;
        var id = self.uid + '-prod-' + key;
        return '<li class="sf-rx-prod' + (chosen ? '' : ' is-added') + '" data-rx-prod="' + key + '">' +
          '<button type="button" class="sf-rx-prod__head" data-rx-prod-toggle aria-expanded="false" aria-controls="' + id + '">' +
          '<span class="sf-rx-prod__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</span>' +
          '<span class="sf-rx-prod__text"><span class="sf-rx-prod__name">' + esc(cfg.setNames[key]) + '</span>' +
          '<span class="sf-rx-prod__for">' + esc(chosen ? T.forZone.replace('[zone]', zoneLabel(z)) : T.monitorTag) + '</span></span>' +
          '<span class="sf-rx-prod__price">' + esc(reco.kit ? T.inKit : formatMoney(self.prices[key])) + '</span>' + chev + '</button>' +
          '<ul class="sf-rx-prod__benefits" id="' + id + '">' + list.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul></li>';
      });
      /* Kit: die Premium Tasche als Gratis-Zeile */
      if (reco.kit && cfg.bag) {
        var bagImg = self.prices.bagImg || '';
        rows.push('<li class="sf-rx-prod sf-rx-prod--bag">' +
          '<div class="sf-rx-prod__head">' +
          '<span class="sf-rx-prod__thumb">' + (bagImg ? '<img src="' + esc(bagImg) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</span>' +
          '<span class="sf-rx-prod__text"><span class="sf-rx-prod__name">' + esc(self.prices.bagName || cfg.bag.name) + '</span>' +
          '<span class="sf-rx-prod__for">' + esc(cfg.bag.tag) + '</span></span>' +
          '<span class="sf-rx-prod__price sf-rx-prod__price--free">' + (Number(cfg.bag.value) > 0 ? '<s>' + esc(formatMoney(cfg.bag.value)) + '</s> ' : '') + esc(T.gratis) + '</span></div>' +
          (cfg.bag.benefit ? '<ul class="sf-rx-prod__benefits"><li>' + esc(cfg.bag.benefit) + '</li></ul>' : '') + '</li>');
      }
      r('prods').innerHTML = rows.join('');
      this.syncProds();

      /* Rechenbeispiel */
      var freq = (goal.frequency || [])[parseInt(st.frequency, 10)] || {};
      var treat = (cfg.treatment || [])[parseInt(st.treatment, 10)] || {};
      var c = cost({ perYear: treat.perYear || 0, perSession: cfg.cost.perSession, hoursPerSession: cfg.cost.hoursPerSession, usesPerWeek: freq.perWeek || 0, months: cfg.cost.months, price: reco.total });
      this.cost = c;
      var costBtn = r('cost-btn');
      var perUse = c.perUse ? formatMoney(c.perUse) : '';
      if (costBtn) {
        costBtn.hidden = !cfg.cost.enabled;
        r('cost-amount').innerHTML = perUse ? ' · ' + esc(T.costLinkAmount).replace('[price]', '<b>' + esc(perUse) + '</b>') : '';
      }
      var perLine = r('per-use-line');
      if (perLine) {
        perLine.hidden = !(cfg.cost.enabled && perUse);
        perLine.innerHTML = perUse ? esc(T.perUseLine).replace('[price]', '<b>' + esc(perUse) + '</b>') : '';
      }
      var years = Math.round(cfg.cost.months / 12 * 10) / 10;
      r('per-use').textContent = perUse;
      r('per-use-2').textContent = perUse;
      r('session').textContent = formatMoney(cfg.cost.perSession);
      r('per-use-sub').textContent = c.uses ? T.perUseSub.replace('[freq]', freq.desc || freq.title || '')
        .replace('[years]', formatNumber(years, years % 1 ? 1 : 0)).replace('[uses]', formatNumber(c.uses)).replace('[total]', formatMoney(reco.total)) : '';
      var line = '';
      if (c.yearlyCost > 0 && c.amortMonths) {
        line = T.costSaved.replace('[amount]', formatMoney(c.yearlyCost))
          .replace('[hours]', formatNumber(c.hours, c.hours % 1 ? 1 : 0))
          .replace('[n]', formatNumber(c.amortMonths)).replace('[unit]', c.amortMonths === 1 ? T.month : T.months);
      }
      r('cost-line').textContent = line;
      r('cost-note').textContent = T.costNoteUse
        .replace('[total]', formatMoney(reco.total)).replace('[count]', formatNumber(c.uses))
        .replace('[session]', formatMoney(cfg.cost.perSession))
        .replace('[months]', formatNumber(cfg.cost.months))
        .replace('[uses]', formatNumber(freq.perWeek || 0, (freq.perWeek || 0) % 1 ? 1 : 0));

      /* Warum diese Empfehlung */
      var why = [];
      var prodNames = productZones.filter(function (z) { return st.zones.indexOf(z) !== -1; }).map(function (z) { return cfg.setNames[lineOf[z]]; });
      why.push(T.whyZones.replace('[zones]', joinDe(st.zones.map(zoneLabel))).replace('[products]', joinDe(prodNames)).replace('[verb]', prodNames.length > 1 ? 'sind' : 'ist'));
      var picks = st.symptoms.map(function (id) {
        var i = self.querySelector('input[name="' + self.uid + '-sym"][value="' + id + '"]');
        var l = i && i.closest('label');
        var t = l && l.querySelector('.sf-rx-check__text');
        return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
      }).filter(Boolean);
      if (picks.length > 3) picks = picks.slice(0, 3).concat([T.morePicks.replace('[n]', String(picks.length - 3))]);
      if (picks.length && T.whyPicks) why.push(T.whyPicks.replace('[picks]', joinDe(picks)));
      if (reco.bootsAdded) why.push(T.whyMonitor);
      if (reco.kit && reco.kitCheaper) why.push(T.whyKitCheaper.replace('[singles]', formatMoney(reco.singleTotal)).replace('[kit]', formatMoney(reco.total)));
      else if (reco.kit) why.push(T.whyKit);
      if (freq.desc && T.whyFrequency) why.push(T.whyFrequency.replace('[freq]', freq.desc || freq.title));
      /* "Fett|Text": der Teil vor dem Strich wird die fette Einleitung */
      r('why').innerHTML = why.map(function (w) {
        var i = w.indexOf('|');
        return '<li>' + (i > 0 ? '<strong>' + esc(w.slice(0, i)) + '</strong> ' + esc(w.slice(i + 1)) : esc(w)) + '</li>';
      }).join('');
      /* Ratgeber-Link: beide Ziele stehen serverseitig im HTML, sichtbar ist nur der zum Ziel passende */
      var goalLinks = this.querySelectorAll('[data-rx-goal-link]');
      for (var gi = 0; gi < goalLinks.length; gi++) goalLinks[gi].hidden = goalLinks[gi].getAttribute('data-rx-goal-link') !== st.goal;
      var link = r('why-link'), L = cfg.links && cfg.links[st.goal];
      if (link) { /* aelteres Markup (Library-Buehne) */
        link.hidden = !(L && L.url);
        if (L && L.url) { link.href = L.url; r('why-link-text').textContent = L.label; }
      }
      var note = r('why-note');
      if (note) { note.textContent = st.goal === 'health' && T.healthNote ? T.healthNote : ''; note.hidden = !note.textContent; }

      /* Summe, Streichpreis mit Label (gleiche Rechnung wie die Buybox) */
      r('total-label').textContent = reco.kit ? T.totalKit : T.total;
      r('price').textContent = formatMoney(reco.total);
      var was = r('was'), save = r('save');
      if (reco.compare) {
        was.hidden = false;
        r('was-label').textContent = reco.kit ? T.wasKit : T.wasSingle;
        was.querySelector('s').textContent = formatMoney(reco.compare);
        save.hidden = false;
        save.textContent = T.save.replace('[amount]', formatMoney(reco.saving)).replace('[pct]', String(reco.savingPct));
      } else {
        was.hidden = true;
        save.hidden = true;
      }

      /* REC-02 Kit-Hinweis */
      var kitrow = r('kit');
      if (kitrow) {
        var hint = reco.kitHint;
        kitrow.hidden = !hint;
        if (hint) {
          r('kit-text').textContent = T.kitDelta.replace('[amount]', formatMoney(hint.delta)) + ': ' + (cfg.kit.desc[hint.key] || cfg.kit.desc['default']);
          var kd = r('kit-delta');
          if (kd) kd.textContent = ' · +' + formatMoney(hint.delta);
        }
      }
      this.renderSizes();
      if (this.chk) this.chk.decorateResult(reco);

      /* Titel zu lang fuer die reservierte Zeile? Dann "Deine Empfehlung" */
      requestAnimationFrame(function () {
        var lh = parseFloat(getComputedStyle(h).lineHeight) || 40;
        if (h.scrollHeight - h.clientHeight > lh * 0.5) h.textContent = T.resultFallback;
      });
    }

    /* Groesse, die der Set-Picker schon haelt (Vorauswahl "Medium"), als Buchstabe */
    pickerSize() {
      try {
        var st = this.picker && this.picker.state;
        if (!st) return null;
        var names = Object.keys(st);
        for (var i = 0; i < names.length; i++) {
          var u = st[names[i]] && st[names[i]].units;
          if (u && u[0] && u[0].size) return String(u[0].size).charAt(0).toUpperCase();
        }
      } catch (e) {}
      return null;
    }

    renderSizes() {
      var reco = this.reco, p = this.prices, self = this;
      if (this.state.sizeChoice === null) {
        var ps = this.pickerSize();
        if (ps) this.state.sizeChoice = ps;
      }
      var box = this.querySelector('[data-rx-r="sizes"]');
      if (!box || !reco) return;
      var stock = (p && p.sizes && p.sizes[reco.kit ? 'kit' : 'boots']) || null;
      [].forEach.call(box.querySelectorAll('input[name="' + this.uid + '-size"]'), function (i) {
        if (!i.value) return;
        var hit = stock ? stock.filter(function (s) { return s.label.charAt(0).toUpperCase() === i.value; })[0] : null;
        var soldOut = !!stock && (!hit || !(hit.stock > 0));
        i.disabled = soldOut;
        i.classList.toggle('disabled', soldOut);
        var lab = i.closest('label');
        if (lab) lab.classList.toggle('is-soldout', soldOut);
        if (soldOut && self.state.sizeChoice === i.value) self.state.sizeChoice = null;
      });
      var chosen = this.state.sizeChoice;
      [].forEach.call(box.querySelectorAll('input[name="' + this.uid + '-size"]'), function (i) { i.checked = chosen !== null && i.value === chosen; });
      var tip = box.querySelector('[data-rx-size-tip]');
      if (tip) tip.hidden = !this.sizeFinder();
    }

    /* Produktzeilen: unter 1280 px aufklappbar (eine offen), ab 1280 px sind alle Vorteile offen */
    toggleProd(btn) {
      if (btn.disabled) return;
      var li = btn.closest('.sf-rx-prod'), open = !li.classList.contains('is-open');
      [].forEach.call(this.querySelectorAll('.sf-rx-prod.is-open'), function (o) {
        o.classList.remove('is-open');
        var b = o.querySelector('[data-rx-prod-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      li.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.guard();
    }

    syncProds() {
      var wide = !!(window.matchMedia && window.matchMedia('(min-width: 1280px)').matches);
      [].forEach.call(this.querySelectorAll('[data-rx-prod-toggle]'), function (b) {
        b.disabled = wide;
        b.setAttribute('aria-expanded', wide || b.closest('.sf-rx-prod').classList.contains('is-open') ? 'true' : 'false');
      });
    }

    /* Groessen-Tipp: derselbe Groessenfinder wie in der Buybox (snippets/sf-size-finder-dialog.liquid,
       API open({ setName, unitLabel, current, availability, apply, restoreFocus })). Er setzt nur die
       Groesse der Empfehlung, nichts im Warenkorb. */
    sizeFinder() {
      var picker = document.querySelector('sf-set-picker[data-size-finder]');
      var host = picker ? document.getElementById(picker.getAttribute('data-size-finder')) : null;
      return host && typeof host.open === 'function' ? host : null;
    }

    openSizeFinder(btn) {
      var host = this.sizeFinder(), self = this;
      if (!host) return;
      var names = this.cfg.setNames;
      var input = function (letter) {
        var L = String(letter || '').trim().charAt(0).toUpperCase();
        return L ? self.querySelector('input[name="' + self.uid + '-size"][value="' + L + '"]') : null;
      };
      host.open({
        setName: this.reco && this.reco.kit ? names.kit : names.boots,
        unitLabel: '',
        current: this.state.sizeChoice || '',
        availability: function (letter) { var i = input(letter); return { exists: !!i, available: !!i && !i.disabled }; },
        apply: function (letter) {
          var i = input(letter);
          if (!i || i.disabled) return { ok: false, message: 'Größe ' + String(letter).charAt(0).toUpperCase() + ' ist gerade nicht verfügbar.' };
          self.state.sizeChoice = i.value;
          self.renderSizes();
          return { ok: true, letter: i.value, label: i.value };
        },
        restoreFocus: function (applied) {
          btn.focus({ preventScroll: true });
          if (!applied) return;
          self.announce('Größe ' + applied.letter + ' übernommen.');
          btn.classList.add('is-done');
          setTimeout(function () { btn.classList.remove('is-done'); }, 2400);
          var face = self.querySelector('input[name="' + self.uid + '-size"]:checked + .sfb-size__chip');
          if (face) { face.classList.add('is-applied'); setTimeout(function () { face.classList.remove('is-applied'); }, 1200); }
        }
      });
    }

    /* ---------------------------------------------------- Ebenen */

    openSheet(id, trigger) {
      var s = this.querySelector('[data-rx-sheet-panel="' + id + '"]');
      if (!s) return;
      var self = this;
      [].forEach.call(this.querySelectorAll('[data-rx-sheet-panel]'), function (o) { if (o !== s) self.closeSheet(o, false); });
      s.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      s._trigger = trigger;
      /* Die Ebene liegt auf allen Breiten ueber der ganzen Ergebnis-Flaeche: beide Spalten inaktiv */
      var inertEls = this.querySelectorAll('[data-rx-sheet-inert], .sf-rx-res__side');
      [].forEach.call(inertEls, function (el) { el.inert = true; });
      var h = s.querySelector('[data-rx-sheet-title]');
      if (h) h.focus({ preventScroll: true });
    }

    closeSheet(s, restoreFocus) {
      if (!s || s.hidden) return;
      s.hidden = true;
      [].forEach.call(this.querySelectorAll('[data-rx-sheet-inert], .sf-rx-res__side'), function (el) { el.inert = false; });
      if (s._trigger) {
        s._trigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) s._trigger.focus({ preventScroll: true });
      }
    }

    /* ---------------------------------------------------- Uebergabe */

    apply(kit) {
      var reco = this.reco;
      if (!reco) return;
      var cfg = this.cfg;
      var lines = kit ? ['kit'] : reco.lines;
      var size = this.state.sizeChoice || null;
      var sets = lines.map(function (k) {
        var s = { name: cfg.setNames[k], qty: 1 };
        if (k === 'boots' || k === 'kit') s.size = size;
        return s;
      });
      var offer = lines.join('+');
      track('rx_cta', { flow: cfg.mode, offer: offer, action: kit ? 'kit' : 'recommendation', size_chosen: !!size });
      this._pending = { offer: offer };
      var self = this;
      if (this.picker && document.body.contains(this.picker)) {
        window.dispatchEvent(new CustomEvent('sf:set-apply', { detail: { sets: sets, replace: true } }));
        clearTimeout(this._fallbackTimer);
        this._fallbackTimer = setTimeout(function () { if (self._pending) self.fallback(); }, 1200);
      } else {
        this.fallback();
      }
    }

    onApplied(e) {
      if (!this._pending) return;
      this._pending = null;
      clearTimeout(this._fallbackTimer);
      var d = (e && e.detail) || {};
      var T = this.cfg.texts;
      var msg = T.applied;
      if (d.skipped && d.skipped.length) {
        var sizeIssue = d.skipped.some(function (s) { return /size/.test(s.reason); });
        msg = sizeIssue ? T.appliedSize : T.appliedPartial;
      } else if (d.ready === false) {
        msg = T.appliedSize;
      }
      this.showNeed(msg);
    }

    fallback() {
      this._pending = null;
      var target = document.querySelector('[data-sf-bundle-block]') || document.querySelector('product-info, .product__info-wrapper, .product-form');
      if (target) {
        var y = target.getBoundingClientRect().top + window.pageYOffset - insets().top - 16;
        window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduceMotion() ? 'auto' : 'smooth' });
        return;
      }
      var url = this.cfg.productUrl;
      if (url) window.location.href = url;
    }
  });
})(this);
